/* eslint-disable import/prefer-default-export */
export const createJobOrderDetailLeftSharedStyles = (theme) => ({
  titleStyle: {
    fontFamily: theme.components.detailLeft.header.typography.fontFamily,
    fontSize: '20px',
    marginTop: '5px',
    marginBottom: '1px',
  },

  boldText: {
    fontFamily: theme.components.detailLeft.header.typography.fontFamily,
    fontSize: '16px',
  },

  subTitleStyle: {
    fontFamily: theme.components.detailLeft.title.typography.fontFamily,
    fontSize: theme.components.detailLeft.title.typography.fontSize,
    marginTop: '3px',
  },

  subText: {
    fontFamily: theme.components.detailLeft.subText.typography.fontFamily,
    fontSize: theme.components.detailLeft.subText.typography.fontSize,
  },

  buttonStyle: {
    width: '100%',
    marginTop: 1,
    fontFamily: theme.components.detailLeft.button.typography.fontFamily,
  },
});
